const SousMass=[
    {
        id:1,
        title:"медово-гірчичний 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"",
    allergy: `🌱 соя ,🍯 мед ,🌶️гірчиця`
    },
    {
        id:2,
        title:"Майонез 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"",
    allergy: `🥚 яйце`
    },
    {
        id:3,
        title:"Кетчуп 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"",
    },
    {
        id:4,
        title:"Часниковий 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"",
    allergy: `🥚 яйце,🌶️гірчиця`
    },
    {
        id:5,
        title:"Тар-тар 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"",
    },
    {
        id:6,
        title:"Гірчиця американська 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"",
    allergy: `🌶️ гірчиця`
    },
    {
        id:7,
        title:"BBQ 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"кетчуп, перець болгарський, часник, цибуля, зелень",
    allergy: `🌱 соя`
    },
    {
        id:8,
        title:"солодкий чілі 40г",
        price:"20 грн",
        src: require('../../../img/orangeLogo.png'),
        text:"",
    },
]

export default SousMass;







